export default __webpack_public_path__ + "static/media/shb-large-logo.aef84f80.svg";